import React, { Fragment } from 'react';

const SortCriteriaCompact = ({ sortCriteria, hidden }) => {
    const selectedOption = [
        ...sortCriteria.filter((sort) => sort.selected === true),
        {},
    ][0];
    return (
        <div
            className={`faceted-search__sort-wrapper ${
                hidden ? 'faceted-search__sort-wrapper--hidden' : ''
            }`}
        >
            <select
                value={selectedOption.value}
                className="form__input"
                aria-label="Sort"
                onChange={(event) => (window.location = event.target.value)}
            >
                {sortCriteria &&
                    sortCriteria.map(({ text, value, selected }, index) => (
                        <option value={value} key={`sorteriaCompact-${index}`}>
                            {text}
                        </option>
                    ))}
            </select>
        </div>
    );
};

export default SortCriteriaCompact;
